export default __webpack_public_path__ + "static/media/bookOne@2x.73f4bcb3.png";